import { render, staticRenderFns } from "./TestsCreate.vue?vue&type=template&id=ad9fbe62&scoped=true&"
import script from "./TestsCreate.vue?vue&type=script&lang=js&"
export * from "./TestsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9fbe62",
  null
  
)

export default component.exports